up.compiler('[blog-post-content]', (element) => {

  let tables = element.querySelectorAll('table')
  for (let i = 0; i < tables.length; ++i) {
    let parent = document.createElement('div')
    let table = tables[i]

    parent.classList.add('table-responsive')
    table.classList.add('table')
    element.insertBefore(parent, table)
    parent.appendChild(table)
  }

  let links = element.querySelectorAll('a')
  for (let i = 0; i < links.length; ++i) {
    let link = links[i]
    if (link.target != '_blank') {
      link.target = '_blank'
    }
  }

});
